export enum RelatorioPagamentoTipo {
  A_RECEBER = 'A_RECEBER',
  RECEBIDOS = 'RECEBIDOS',
  INADIMPLENTES = 'INADIMPLENTES',
}
